import React from 'react';
import { useSelector } from 'react-redux'; 
import DarkModeToggle from './DarkModeToggle';
import Avatar from 'react-avatar';
import { clearActiveAccountId } from '../utils/persist'; 

import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from '@headlessui/react'
import {
  Bars3Icon,
  BellIcon,
} from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

const logout_url = `${process.env.REACT_APP_BASE_API_URL}/mvapi-ui/auth/logout`;


const Topbar = ({ setSidebarOpen }) => {
  const person = useSelector((s) => s.globalData.person);
  const authUser = useSelector((s) => s.auth.user);
  const displayName = person?.name || authUser?.name || authUser?.email || 'User';

  const handleLogout = () => {
    try {
      // clear app data
      localStorage.removeItem('token');
      localStorage.removeItem('connectors_data');
      localStorage.removeItem('optinOptoutPolicies_data');
      localStorage.removeItem('senders_data');
      localStorage.removeItem('templates_data');

      // ⬅️ ensure the selected account is cleared BEFORE leaving the app
      clearActiveAccountId();
    } finally {
      // go to server logout endpoint (full page nav)
      window.location.href = logout_url;
    }
  };

  return (
    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-black px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      <button
        type="button"
        onClick={() => setSidebarOpen(true)}
        className="-m-2.5 p-2.5 text-gray-700 dark:text-gray-300 lg:hidden"
      >
        <span className="sr-only">Open sidebar</span>
        <Bars3Icon aria-hidden="true" className="size-6" />
      </button>

      <div aria-hidden="true" className="h-6 w-px bg-gray-900/10 dark:bg-gray-100/10 lg:hidden" />

      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <form action="#" method="GET" className="grid flex-1 grid-cols-1" />
        <div className="flex items-center gap-x-4 lg:gap-x-6">
          <DarkModeToggle />

          <button
            type="button"
            className="-m-2.5 p-2.5 text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
          >
            <span className="sr-only">View notifications</span>
            <BellIcon aria-hidden="true" className="size-6" />
          </button>

          <div aria-hidden="true" className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10 dark:lg:bg-gray-100/10" />

          {/* Profile dropdown */}
          <Menu as="div" className="relative">
            <MenuButton className="-m-1.5 flex items-center p-1.5">
              <span className="sr-only">Open user menu</span>
              <Avatar name={displayName} round size="32" textSizeRatio={2.2} />
              <span className="hidden lg:flex lg:items-center">
                <span aria-hidden="true" className="ml-4 text-sm/6 font-semibold text-gray-900 dark:text-gray-100">
                  {displayName}
                </span>
                <ChevronDownIcon aria-hidden="true" className="ml-2 size-5 text-gray-600 dark:text-gray-400" />
              </span>
            </MenuButton>

            <MenuItems
              transition
              className="absolute right-0 z-10 mt-2.5 w-40 origin-top-right rounded-md bg-white dark:bg-black py-2 shadow-lg ring-1 ring-gray-900/5 dark:ring-gray-100/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
            >
              <MenuItem>
                <a
                  href="#"
                  className="block px-3 py-1 text-sm/6 text-gray-900 dark:text-gray-100 data-[focus]:bg-gray-50 dark:data-[focus]:bg-gray-900 data-[focus]:outline-none"
                >
                  Your profile
                </a>
              </MenuItem>

              {/* Sign out: call handler, then navigate to logout_url */}
              <MenuItem>
                <button
                  type="button"
                  onClick={handleLogout}
                  className="block w-full text-left px-3 py-1 text-sm/6 text-gray-900 dark:text-gray-100 data-[focus]:bg-gray-50 dark:data-[focus]:bg-gray-900 data-[focus]:outline-none"
                >
                  Sign out
                </button>
              </MenuItem>
            </MenuItems>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
